/** @format */

export * from './text-link.module';
